<template>
  <!-- eslint-disable -->
  <div class="message-item">
    <div class="message-item__settings-wrapper">
      <div class="d-flex align-center">
        <v-text-field
          class="message-item__settings--delay panzoom-ignore"
          v-model="node.delay"
          :label="'Delay'"
          persistent-placeholder
          :placeholder="'0'"></v-text-field>
      </div>
    </div>

    <v-btn v-if="!showEditor" class="d-flex" text outlined @click="showEditor = true"> Content Edit </v-btn>

    <div v-if="!showEditor">
      <div class="content-preview-label">Content preview</div>
      <div class="text-left content-preview" v-html="node.content"></div>
    </div>

    <va-tinymce-input
      v-if="showEditor"
      ref="tinymce"
      class="mb-4 w-full"
      :current-content="node.content"
      :editor-height="120"
      live-chat-message-preset
      title="Message"
      :forced-root-block-attrs="{ class: 'live-chat-message' }"
      auto-resize
      @update="content => updateMessageContent(content)" />

    <div class="d-flex align-start">
      <div class="message-item__label">
        {{ $t("shortcodes.live_chat_auto.input_question_preview") }}
      </div>
    </div>
    <div class="d-flex align-start">
      <img class="input-question-preview__img" :src="currentImage" />
    </div>
    <v-btn v-if="!showButtonEditor" class="d-flex mb-2" text outlined small @click="showButtonEditor = true">
      Button Text Edit
    </v-btn>
    <div v-if="!showButtonEditor && node.buttonText" class="mb-2">
      <div class="content-preview-label">Button text preview</div>
      <div class="text-left content-preview" style="color: #000000" v-html="node.buttonText"></div>
    </div>
    <va-tinymce-input
      v-if="showButtonEditor"
      class="mb-4 w-full"
      :current-content="node.buttonText"
      :editor-height="80"
      text-only
      title="Button text"
      auto-resize
      @update="content => updateButtonText(content)" />
    <div>
      <VaColorPicker
        class="mb-4 panzoom-ignore"
        :title="'Button background color'"
        mode="hexa"
        v-model="node.buttonColor"></VaColorPicker>
    </div>
    <div>
      <VaColorPicker
        class="mb-4 panzoom-ignore"
        :title="'Button text color'"
        mode="hexa"
        v-model="node.buttonTextColor"></VaColorPicker>
    </div>
    <div>
      <VaColorPicker
        class="mb-4 panzoom-ignore"
        :title="'Button border color'"
        mode="hexa"
        v-model="node.buttonBorderColor"></VaColorPicker>
    </div>
    <div>
      <v-checkbox
        class="mb-3"
        :label="'Display user answer'"
        v-model="node.displayUserAnswer"
        color="primary"
        hide-details="auto">
      </v-checkbox>
    </div>
  </div>
</template>

<script>
  import birthYearImg from "@/assets/images/input-question/birthYear.png";
  import enterAgeImg from "@/assets/images/input-question/enterAge.png";
  import birthYearUnderscoreImg from "@/assets/images/input-question/birthYearUnderscore.png";
  import VaColorPicker from "@/components/custom/VaColorPicker";

  export default {
    name: "MultiStepFormInputQuestion",
    components: { VaColorPicker },

    props: {
      node: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        currentImage: "",
        showEditor: !this.node?.content,
        showButtonEditor: !this.node?.buttonText,
      };
    },
    mounted() {
      const questionPreviewImages = {
        enter_age: enterAgeImg,
        enter_birth_year: birthYearImg,
        enter_birth_year_underscore: birthYearUnderscoreImg,
      };

      this.currentImage = questionPreviewImages[this.node.inputQuestionType] || null;
    },
    methods: {
      updateMessageContent(content) {
        // eslint-disable-next-line vue/no-mutating-props
        this.node.content = content;
      },
      updateButtonText(content) {
        // eslint-disable-next-line vue/no-mutating-props
        this.node.buttonText = content;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "@core/preset/preset/typography/index.scss";

  .input-question-preview__img {
    max-width: 240px;
  }

  .message-item__label {
    @include text-caption-bold();
    color: get-color("subtitle");
    margin-bottom: 10px;
  }
</style>
